module.exports = __webpack_public_path__ + "img/image14.cec0f857.png";